var $7a42c3dae25ebf3e$exports = {};
$7a42c3dae25ebf3e$exports = {
    "Empty": `Leeg`
};


export {$7a42c3dae25ebf3e$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
